import React from 'react';
import ExpandButton from './expand_button';
import TreeLineButton from './tree_line_button';
import TreeLine, { TreeLineModes } from './tree_line';
import { formatCellDisplay } from '../utils/formatting';
import { EXPANSION_STATUS } from '../utils/toggle';
import { PLACEMENT, ROW_TYPES } from '../utils/oppu_hierarchy';

const COMPONENTS_THAT_DISPLAY_CHANNEL = ['UNITS', 'GMS'];
const COMPONENTS_REQUIRE_CAPITAL_NAMES = ['GMS'];

/**
 * Displays the cell contents of the 'Component' column.
 * Renders the tree lines, expand buttons, etc. and
 * including the component display name.
 */
export default class ComponentCellDisplay extends React.Component {
  deriveButtonDisplayMode = (item) => {
    const { type, childrenPlacement } = item.rowMetaInfo || {};

    if (type === ROW_TYPES.SUB_SECTION_HEAD && childrenPlacement === PLACEMENT.TOP) {
      return TreeLineModes.L;
    }

    if (childrenPlacement === PLACEMENT.BOTTOM) {
      return item.status === EXPANSION_STATUS.EXPAND ? TreeLineModes.None : TreeLineModes.Bottom;
    }

    return TreeLineModes.None;
  };

  deriveTreeLineDisplayMode = (item) => {
    const { type, parentPlacement } = item.rowMetaInfo || {};

    if (type === ROW_TYPES.FIRST_CHILD) {
      return parentPlacement === PLACEMENT.TOP ? TreeLineModes.Default : TreeLineModes.UpsideDownL;
    }

    if (type === ROW_TYPES.LAST_CHILD) {
      return parentPlacement === PLACEMENT.TOP ? TreeLineModes.L : TreeLineModes.Default;
    }

    return TreeLineModes.Default;
  };

  getComponentDisplayName = (componentKey, componentName, requiredChannels, item) => {
    const displayName =
      COMPONENTS_THAT_DISPLAY_CHANNEL.includes(componentKey) && requiredChannels.includes('all')
        ? item.channel
        : componentName;

    return COMPONENTS_REQUIRE_CAPITAL_NAMES.includes(componentKey) ? displayName.toUpperCase() : displayName;
  };

  render() {
    const { item, mapping, onToggleExpand, requiredChannels } = this.props;
    const { children, status, level, component: componentName, loading } = item;

    const componentKey = componentName ? componentName.trim().replace(/\s/g, '_').toUpperCase() : '';
    const url = mapping[componentKey] ? mapping[componentKey] : null;

    const componentDisplayName = this.getComponentDisplayName(componentKey, componentName, requiredChannels, item);

    const cellContent = formatCellDisplay(componentDisplayName, 'string', false, item);

    const componentItem = url ? (
      <a href={url} target="_blank">
        {cellContent}
      </a>
    ) : (
      cellContent
    );

    return (
      <div style={{ width: '200px', display: 'table', marginLeft: 2 * level + `rem` }}>
        <div style={{ display: 'table-row' }}>
          <div style={{ display: 'table-cell', width: '40px', verticalAlign: 'top' }}>
            {children ? (
              <div>
                {item.level > 1 ? <TreeLine level={level} mode={this.deriveTreeLineDisplayMode(item)} /> : <div />}
                <TreeLineButton
                  level={level}
                  mode={this.deriveButtonDisplayMode(item)}
                  expandButton={
                    <ExpandButton status={status} onClick={(event) => onToggleExpand(event, item)} loading={loading} />
                  }
                />
              </div>
            ) : (
              <TreeLine level={level} mode={this.deriveTreeLineDisplayMode(item)} />
            )}
          </div>
          <div style={{ display: 'table-cell', verticalAlign: 'middle' }}> {componentItem} </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/components/component_cell_display.js